import { formatISO } from 'date-fns';
import { useBoardService } from 'src/features/boards';
import { v4 as uuid } from 'uuid';

import { CommentSlice, CreateCommentSlice } from '../types';
const { addComment, deleteComment, updateComment } = useBoardService();
export const createCommentSlice: CreateCommentSlice = (set, get): CommentSlice => ({
  onAddComment: async ({ columnId, comment, itemIndex, itemId, tags, text }) => {
    let foundColumnIndex = -1;
    set((state) => {
      foundColumnIndex = state.columns.findIndex((obj) => obj.id === columnId);
      if (foundColumnIndex > -1) {
        if (!state.columns[foundColumnIndex].items[itemIndex].comments) {
          state.columns[foundColumnIndex].items[itemIndex].comments = [];
        }
        state.columns[foundColumnIndex].items[itemIndex].comments?.unshift({
          id: uuid(),
          data: comment,
          createdAt: formatISO(new Date()),
          member: {
            firstname: state.currentUser.firstname,
            lastname: '',
            email: state.currentUser.email,
            memberId: state.currentUser.id,
            avatar: state.currentUser.avatar,
          },
        });
      }
    });
    if (foundColumnIndex > -1) {
      const item = await addComment({
        boardId: itemId,
        content: comment,
        itemId: itemId,
        text: text,
        tags: tags,
      });
      if (item) {
        get().setItem({ columnId: item.columnId, itemId: itemId, item });
      }
    }
  },
  onDeleteComment: async ({ commentId, columnId, itemIndex }) => {
    let foundColumnIndex = -1;
    set((state) => {
      foundColumnIndex = state.columns.findIndex((obj) => obj.id === columnId);

      if (foundColumnIndex > -1) {
        if (state.columns[foundColumnIndex].items[itemIndex].comments?.length) {
          state.columns[foundColumnIndex].items[itemIndex].comments = state.columns[
            foundColumnIndex
          ].items[itemIndex].comments?.filter((comment) => comment.id !== commentId);
        }
      }
    });
    if (foundColumnIndex > -1) {
      const item = await deleteComment({ commentId });
      if (item && item.id) {
        get().setItem({ columnId: item.columnId, itemId: item.id, item });
      }
    }
  },
  onUpdateComment: async ({ commentId, columnId, itemIndex, comment, tags, text }) => {
    let foundColumnIndex = -1;
    set((state) => {
      foundColumnIndex = state.columns.findIndex((obj) => obj.id === columnId);

      if (foundColumnIndex > -1) {
        if (state.columns[foundColumnIndex].items[itemIndex].comments?.length) {
          const foundCommentIndex = state.columns[foundColumnIndex].items[
            itemIndex
          ].comments?.findIndex((obj) => obj.id === commentId);
          if (foundCommentIndex !== undefined && foundCommentIndex > -1) {
            const commentObj = state.columns[foundColumnIndex].items[itemIndex].comments?.find(
              (obj) => obj.id === commentId
            );
            if (commentObj?.data) commentObj.data = comment;
          }
        }
      }
    });
    if (foundColumnIndex > -1) {
      const item = await updateComment({
        commentId,
        content: comment,
        text: text,
        tags: tags,
      });
      if (item && item.id) {
        get().setItem({ columnId: item.columnId, itemId: item.id, item });
      }
    }
  },
});
